import styles from "./Settings.module.scss";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { useEffect } from "react";
import useAppSelector from "../../hooks/useAppSelector";
import { setProfileImage } from "../../helper/imagePaths";
import UploadFile from "../../components/UploadFile/UploadFile";
import { IUser } from "../../models/User";

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = useAppSelector((state) => state.userProfileSlice.user) as IUser;

  useEffect(() => {
    if (location.pathname === "/settings") {
      navigate("/settings/account");
    }
  }, [navigate, location]);

  return (
    <div className={"container"}>
      <div className={styles.container}>
        <div className={styles.menuWrapperContainer}>
          <div className={styles.menuWrapper}>
            <div className={styles.imageWrapper}>
              <div
                className={styles.profileImage}
                style={{ backgroundImage: `url(${setProfileImage(user)})` }}
              ></div>
              <UploadFile />
            </div>
            <ul className={styles.list}>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/account"}
                >
                  {t("Account")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/personal-information"}
                >
                  {t("PersonalInformation")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/contact"}
                >
                  {t("Contact")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/billing-cards"}
                >
                  {t("Billing")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/recent-charges"}
                >
                  {t("RecentCharges")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/loyalty-points"}
                >
                  {t("LoyaltyPoints")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={"/settings/refer-friends"}
                >
                  {t("ReferFriends")}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.outlet}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Settings;
